const VIDEO_FILE = /\.(mp4|mov|webm|avi|mkv)$/i;

export const DEFAULT_IMAGE_SECONDS = 10;
const MIN_IMAGE_SECONDS = 3;
const MAX_IMAGE_SECONDS = 300;

export const isVideo = (ad) => VIDEO_FILE.test(ad?.file_url || '');

// The same ads in the same order, so a refresh that changed nothing does not restart the loop.
export const sameList = (a, b) =>
    a.length === b.length &&
    a.every((ad, i) => ad.id === b[i].id && ad.file_url === b[i].file_url && ad.timeout === b[i].timeout);

export const sortByRank = (ads) => [...ads].sort((a, b) => (a.rank || 0) - (b.rank || 0));

// A zero or negative timeout would otherwise flip through images instantly.
export const imageSeconds = (ad) => {
    const seconds = Number(ad?.timeout) || DEFAULT_IMAGE_SECONDS;
    return Math.min(MAX_IMAGE_SECONDS, Math.max(MIN_IMAGE_SECONDS, seconds));
};

// Only the previous, current and next ads stay mounted, so the next one loads ahead
// without every file in the playlist loading at once.
export const mountedIndices = (current, count) => {
    if (count === 0) return [];
    return [...new Set([(current - 1 + count) % count, current, (current + 1) % count])];
};
